export default "/assets/7e06644bbdc83069cec8d396149da3ab.woff";